import React from "react";
import { FaChevronRight } from "react-icons/fa6";
import { useLocation, useHistory } from "react-router-dom/cjs/react-router-dom.min";
import allPaths from "../../Config/paths"

const BackgroundImage = (props) => {
    const { selectedLanguage, heading, mainClass, screenName } = props
    const location = useLocation()
    const history = useHistory()
    return (
        <div className={`fourth-design-banner ${mainClass}`}>
            <div className="fourth-design-banner-text-div">
                <h1>{heading}</h1>
                <h2>
                    {screenName}
                </h2>
                {location?.pathname == '/fourth-design/contact' ? <button onClick={() => history?.push(allPaths?.FOURHTHOME)}>
                    {selectedLanguage?.txt_Home}
                </button> : null}
            </div>
        </div>
    )
}

export default BackgroundImage